import { connect } from "react-redux";
import Draggable from "react-draggable";
import { TailSpin } from "react-loader-spinner";

import { EMPTY_STRING } from "../../../constants";
import { isTransactionInProgress } from "../../utility";
import { useScreenWidth, useScreenHeight } from "../../hooks/windowResize";

const DraggableNotification = (props) => {
  const { spinnerArray, isInventoryImporting } = props;
  const [screenWidth] = useScreenWidth();
  const [screenHeight] = useScreenHeight();
  let isVisible = false;
  let message = EMPTY_STRING;
  // import inventory
  if (isInventoryImporting?.isVisible) {
    isVisible = true;
    message = isInventoryImporting.message;
  }
  // sale transaction
  else if (isTransactionInProgress(spinnerArray)) {
    isVisible = true;
    message = "Processing...";
  }
  let notificationWidth = 280;
  let notificationHeight = 110;
  if (message.length < 30) {
    notificationWidth = 220;
    notificationHeight = 70;
  }

  const handleBounds = () => {
    return {
      left: 10,
      top: 10,
      right: screenWidth - notificationWidth,
      bottom: screenHeight - notificationHeight,
    };
  };

  return (
    isVisible && (
      <Draggable
        handle=".draggable-notification"
        bounds={handleBounds()}
        defaultPosition={{
          x: screenWidth - notificationWidth,
          y: screenHeight - notificationHeight,
        }}
      >
        <div className="draggable-notification d-flex justify-content-center align-items-center gap-3">
          <TailSpin
            type="TailSpin"
            color="#6a18ed"
            height={25}
            width={25}
            strokeWidth={4}
          />
          <p className="m-0">{message}</p>
        </div>
      </Draggable>
    )
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  spinnerArray: state.system.spinnerArray,
  isInventoryImporting: state.inventory.isInventoryImporting,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = () => ({});

//-------Export AddNewUser Component
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DraggableNotification);
